import { TAppState } from '../../types/appState';
import { EAvailableActions } from '../../types/availableActions';
import { TOpenedChat } from '../../types/openedChats';
import { IUserInChatListSchema } from '../../types/userData';

export type TCurrentOpenedChat = TOpenedChat & {
  blocked?: boolean;
  availableActions?: EAvailableActions[] | null;
  users: IUserInChatListSchema[];
  botId?: number | null;
};

export function currentOpenChatSelector(state: TAppState): TCurrentOpenedChat | null {
  const { chatList, chatWindow, openedChats } = state;

  const currentOpenedChatId =
    chatWindow.currentOpenedChatId || chatList.removedFromSpamChatId || chatList.removedFromArchiveChatId;

  const currentChat = currentOpenedChatId !== undefined && openedChats[currentOpenedChatId];

  const currentChatListItem = chatList.chats.find(chat => chat.chatId === currentOpenedChatId);

  const blocked = currentChatListItem ? currentChatListItem.blocked : undefined;
  const availableActions = currentChatListItem ? currentChatListItem.availableActions : null;
  const users = currentChatListItem ? currentChatListItem.users : [];
  const botId = currentChatListItem ? currentChatListItem.botId : undefined;

  return currentChat ? { ...currentChat, blocked, availableActions, users, botId } : null;
}
